import { render, staticRenderFns } from "./surveillancePersonInfo.vue?vue&type=template&id=02721d94&scoped=true&"
import script from "./surveillancePersonInfo.vue?vue&type=script&lang=js&"
export * from "./surveillancePersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./surveillancePersonInfo.vue?vue&type=style&index=0&lang=less&"
import style1 from "./surveillancePersonInfo.vue?vue&type=style&index=1&id=02721d94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02721d94",
  null
  
)

export default component.exports